<template>
  <div>
    <div v-if="totalResponsible" class="grid_responsible_header">
      <div class="cell justify-center text-center">{{ localStorage.translations.pages['setting-personal_area'].labels['imya'] }}</div>
      <div class="cell justify-center text-center">{{ localStorage.translations.pages.projects['reports_table']['preliminary'] }}</div>
      <div class="cell justify-center text-center">{{ t['responsible_approved'] }}</div>
    </div>
    <div v-else :class="headerClass">
      <div class="cell">{{ byDays ? (localStorage.translations.pages.common.text['date'] || 'Date') : t.position}}</div>
      <div v-if="showProjectId" class="cell">{{ localStorage.translations.pages.common.text['project_id'] || 'Project ID' }}</div>
      <div class="cell">{{ t.project }}</div>
      <div v-if="byDays && showTimestamp" class="cell justify-center text-center">{{ t.timestamp || 'Timestamp' }}</div>
      <div class="cell justify-center text-center">{{ t.hours || 'Hours' }}</div>
      <div class="grid_row">
        <div class="grid_quantity">
          <div class="cell justify-center text-center">{{ t['reported'] }}</div>
          <div class="cell">
            <div v-if="$slots.first" class="my-n1">
              <slot name="first"/>
            </div>
            <v-sheet color="transparent" width="100%" class="text-center">
              {{ invoicedTitle }}
            </v-sheet>
          </div>
          <div class="cell justify-center text-center">{{ t['pay'] }}</div>
          <div class="cell justify-center text-center">{{ t['rate'] }}</div>
          <div class="cell justify-center text-center">{{ localStorage.translations.pages.finance['invoice-table']['sum'] }}</div>
        </div>
        <div class="cell justify-center text-center">{{ t.quantity }}</div>
      </div>
      <template v-if="responsibleTotalShow">
        <div class="grid_row responsible_header_cell">
          <div class="cell justify-center text-center">{{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}</div>
          <div class="grid_charge">
            <div class="cell justify-center text-center">{{ t['rate'] }}</div>
            <div class="cell">
              <div v-if="$slots.second" class="my-n1">
                <slot name="second"/>
              </div>
              <v-sheet color="transparent" width="100%" class="text-center">
                {{ t['premium'] }}
              </v-sheet>
            </div>
            <div class="cell justify-center text-center">{{ localStorage.translations.pages['setting-personal_area'].labels['imya'] }}</div>
          </div>
        </div>
      </template>
      <template v-if="byDays">
        <div class="grid_days_inner_note">
          <div class="cell">{{ t.work }}</div>
          <div class="cell">{{ t.notes }}</div>
        </div>
      </template>
      <div v-else class="cell">{{ t.work }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinanceSalarySliceShowTableHeader",
  props: {
    totalResponsible: Boolean,
    responsibleTotalShow: Boolean,
    checkResponsible: Boolean,
    byDays: Boolean,
    showProjectId: {
      type: Boolean,
      default: false,
    },
    showTimestamp: {
      type: Boolean,
      default: false,
    },
    useForemanApprovedTitle: Boolean,
  },
  computed: {
    invoicedTitle() {
      return this.useForemanApprovedTitle
        ? this.localStorage.translations.pages.common.text['approved_by_forema'] || this.t['invoiced']
        : this.t['invoiced']
    },
    headerClass() {
      if (this.byDays && this.showTimestamp) {
        if (this.showProjectId) {
          return this.responsibleTotalShow
            ? 'grid_header_by_days_timestamp_project_id'
            : 'grid_header_by_days_timestamp_no_responsible_project_id'
        }
        return this.responsibleTotalShow
          ? 'grid_header_by_days_timestamp'
          : 'grid_header_by_days_timestamp_no_responsible'
      }
      if (this.showProjectId) {
        return this.responsibleTotalShow ? 'grid_header_project_id' : 'grid_header_no_responsible_project_id'
      }
      return this.responsibleTotalShow ? 'grid_header' : 'grid_header_no_responsible'
    },
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    }
  }
}
</script>
